/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class WinterHoardSoundConfig implements ISoundConfig {

    public static instance:WinterHoardSoundConfig = new WinterHoardSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";

    BASIC_GAME_AMBIANCE:string = "bg_main";
    FREE_SPIN_AMBIANCE:string = "bg_freespins";
    BIG_WIN_MUSIC:string = "higwins_bg";

    REELS_SPIN_START:string[] = ["fx_reel_spin"];

    REELS_DEFAULT_BOUNCE:string[] = ["fx_reel_landing", "fx_reel_landing", "fx_reel_landing", "fx_reel_landing", "fx_reel_landing"];

    public static TINY_WIN:string = "win_tiny";
    public static SMALL_WIN:string = "win_small";
    public static MEDIUM_WIN:string = "win_medium";
    public static LARGE_WIN:string = "win_large";
    public static BIG_WIN:string = "fx_level_1";
    public static MEGA_WIN:string = "fx_level_2";
    public static SUPER_MEGA_WIN:string = "fx_level_3";
    public static COUNT_UP_LOOP:string ="win_counter";
    public static COUNT_UP_COIN_LOOP:string ="win_counter_coins";
    public static COUNT_UP_END:string ="win_counter_end";
    public static WIN_LINE:string ="fx_winLine";


    public static BIG_WIN_START:string = "fx_highwin_start";
    public static BIG_WIN_END:string = "fx_highwin_end";

    public static MYSTERY_SYMBOL_REVEAL:string = "fx_mystery_colums";
    public static SHAMAN_TRIGGER:string = "shamanTrigger";
    public static SHAMAN_SYMBOLS_APPEAR:string = "shamanSymbolsAppear";
    public static SYMBOL_CHANGE_ON_METER:string = "fx_change_symbol";
    public static PURPLE_DOT_FLY_TO_METER:string = "fx_symbol_fly";

    public static SCATTER_COUNTER_UP:string[] = ["fx_scatter_1","fx_scatter_2","fx_scatter_3"];
    public static ANTICIPATION:string = "fx_anticipation";
    public static ANTICIPATION_FAIL:string = "fx_anticipation_fail";
    public static WILD_LANDING:string = "fx_wild_landing";
    public static FREESPIN_START:string = "popup_fs_start";
    public static PICK_AND_CLICK_EFFECT:string = "fx_fs_click";
    public static FREESPIN_END:string = "popup_fs_out";

    constructor() {
        if(WinterHoardSoundConfig.instance) {
            throw new Error("WinterHoardSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}